import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export class NADCollectionSlider {
  private element: HTMLElement;
  private swiper: Swiper | null = null;
  private scrollObserver: IntersectionObserver | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.init();
  }

  private init(): void {
    this.initSwiper();
    this.setupResizeListener();
    this.setupScrollAnimation();
  }

  private initSwiper(): void {
    const swiperElement = this.element.querySelector('.nad-collection-slider__products');
    if (!swiperElement) return;

    // Only initialize Swiper on desktop (768px and above)
    if (window.innerWidth >= 768) {
      this.swiper = new Swiper(swiperElement as HTMLElement, {
        modules: [Navigation],
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        spaceBetween: 20,
        slidesPerView: 3,
        centeredSlides: false,
        loop: false,
        breakpoints: {
          1280: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          1680: {
            slidesPerView: 5,
            spaceBetween: 16,
          },
        },
      });

      console.log('NADCollectionSlider Swiper initialized for desktop');
    } else {
      // On mobile, add CSS class for grid layout
      swiperElement.classList.add('nad-collection-slider__products--mobile-grid');
      console.log('NADCollectionSlider using grid layout for mobile');
    }
  }

  private setupResizeListener(): void {
    let resizeTimeout: NodeJS.Timeout;
    
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.handleResize();
      }, 250);
    });
  }

  private handleResize(): void {
    const swiperElement = this.element.querySelector('.nad-collection-slider__products');
    if (!swiperElement) return;

    const isDesktop = window.innerWidth >= 768;
    const hasMobileGrid = swiperElement.classList.contains('nad-collection-slider__products--mobile-grid');

    // Destroy existing instance
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    // Remove mobile grid class
    if (hasMobileGrid) {
      swiperElement.classList.remove('nad-collection-slider__products--mobile-grid');
    }

    // Initialize appropriate mode
    if (isDesktop) {
      this.initSwiper();
    } else {
      swiperElement.classList.add('nad-collection-slider__products--mobile-grid');
    }
  }

  private setupScrollAnimation(): void {
    const options = {
      root: null,
      rootMargin: '0px 0px -20% 0px',
      threshold: 0.1
    };

    this.scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.element.classList.add('nad-collection-slider--visible');
          console.log('NADCollectionSlider: Section became visible', this.element.id);
        }
      });
    }, options);

    this.scrollObserver.observe(this.element);
  }

  public destroy(): void {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    
    if (this.scrollObserver) {
      this.scrollObserver.disconnect();
      this.scrollObserver = null;
    }
  }

  public static initializeAll(): void {
    document.querySelectorAll<HTMLElement>('.nad-collection-slider').forEach((element) => {
      if (!(element as any)._nadCollectionSliderInstance) {
        (element as any)._nadCollectionSliderInstance = new NADCollectionSlider(element);
      }
    });
  }

  public static destroySection(element: HTMLElement): void {
    const instance = (element as any)._nadCollectionSliderInstance;
    if (instance && typeof instance.destroy === 'function') {
      instance.destroy();
      delete (element as any)._nadCollectionSliderInstance;
    }
  }
}